import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';

/**
 * Flags a delivery/invoice detail line whose batches or labels were picked by
 * hand at delivery time (`OrderDetailAttributes.deliveryLabelsManuallySelect`,
 * written by the mobile app — this app only displays it). Renders nothing when
 * `manuallySelected` is false.
 *
 * `showText` switches the presentation: icon + tooltip for a grid cell
 * (`showText` false, the default), icon + the full sentence for the batch
 * manager modal header (`showText` true). The icon keeps its aria-label in both
 * modes, so the meaning reaches a screen reader even where the tooltip cannot.
 */
@Component({
  selector: 'app-manual-label-selection-indicator',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './manual-label-selection-indicator.component.html',
  styleUrl: './manual-label-selection-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManualLabelSelectionIndicatorComponent {
  manuallySelected = input<boolean>(false);
  showText = input<boolean>(false);
}
